import { DashboardDefinition } from '@/app/pages/dashboard/models/dashboard.models';

export const CUSTOMER_DASHBOARD: DashboardDefinition = {
  key: 'customer',
  title: 'Customer Dashboard',
  subtitle:
    'See your active freight, delivery performance, and spend at a glance.',
  theme: 'customer',
  asmOnly: false,
  defaultWidgetIds: [
    'trackShipment',
    'activeShipments',
    'inboundShipments',
    'totalDisplay',
    'shipmentStatusChart',
    'shipmentDeliveryChart',
    'spendByMonth',
    'loadHistory',
  ],
};
